function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "sh-shell"
};
var _hoisted_2 = {
  key: 0,
  "class": "sh-embed-hero"
};
var _hoisted_3 = {
  "class": "sh-layout"
};
var _hoisted_4 = {
  "class": "sh-stack"
};
var _hoisted_5 = {
  "class": "sh-card sh-panel"
};
var _hoisted_6 = {
  "class": "sh-plan-grid"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  "class": "t"
};
var _hoisted_9 = {
  "class": "s"
};
var _hoisted_10 = {
  key: 0,
  "class": "sh-note sh-note-pos"
};
var _hoisted_11 = {
  "class": "sh-card sh-panel"
};
var _hoisted_12 = {
  "class": "sh-field-grid"
};
var _hoisted_13 = {
  "class": "sh-field"
};
var _hoisted_14 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_15 = {
  "class": "sh-tip"
};
var _hoisted_16 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_17 = ["value"];
var _hoisted_18 = {
  "class": "sh-field"
};
var _hoisted_19 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_20 = {
  "class": "sh-tip"
};
var _hoisted_21 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_22 = ["value"];
var _hoisted_23 = {
  "class": "sh-field"
};
var _hoisted_24 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_25 = {
  "class": "sh-tip"
};
var _hoisted_26 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_27 = ["value"];
var _hoisted_28 = {
  "class": "sh-field"
};
var _hoisted_29 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_30 = {
  "class": "sh-tip"
};
var _hoisted_31 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_32 = ["value"];
var _hoisted_33 = {
  "class": "sh-field-grid sh-grid-top"
};
var _hoisted_34 = {
  "class": "sh-field"
};
var _hoisted_35 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_36 = ["value"];
var _hoisted_37 = {
  "class": "sh-field"
};
var _hoisted_38 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_39 = {
  key: 0,
  "class": "sh-simple-note"
};
var _hoisted_40 = {
  "class": "sh-divider-top sh-advanced"
};
var _hoisted_41 = {
  "class": "sh-advanced-title"
};
var _hoisted_42 = {
  key: 0,
  "class": "sh-advanced-body"
};
var _hoisted_43 = {
  "class": "sh-toggle-grid"
};
var _hoisted_44 = ["aria-checked"];
var _hoisted_45 = {
  "class": "sh-toggle-label"
};
var _hoisted_46 = {
  "class": "sh-toggle-hint"
};
var _hoisted_47 = ["aria-checked"];
var _hoisted_48 = {
  "class": "sh-field-grid"
};
var _hoisted_49 = {
  "class": "sh-field"
};
var _hoisted_50 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_51 = {
  "class": "sh-tip"
};
var _hoisted_52 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_53 = ["value"];
var _hoisted_54 = {
  "class": "sh-field"
};
var _hoisted_55 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_56 = {
  "class": "sh-tip"
};
var _hoisted_57 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_58 = ["value"];
var _hoisted_59 = ["aria-checked"];
var _hoisted_60 = {
  "class": "sh-toggle-label"
};
var _hoisted_61 = {
  "class": "sh-toggle-hint"
};
var _hoisted_62 = ["aria-checked"];
var _hoisted_63 = {
  "class": "sh-toggle-label"
};
var _hoisted_64 = {
  "class": "sh-toggle-hint"
};
var _hoisted_65 = {
  key: 0,
  "class": "sh-field"
};
var _hoisted_66 = {
  "class": "sh-field-caption sh-muted"
};
var _hoisted_67 = {
  "class": "sh-tip"
};
var _hoisted_68 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_69 = ["value"];
var _hoisted_70 = {
  "class": "sh-card sh-panel"
};
var _hoisted_71 = {
  "class": "sh-display sh-compare-head"
};
var _hoisted_72 = {
  "class": "sh-compare-list"
};
var _hoisted_73 = {
  "class": "sh-compare-track"
};
var _hoisted_74 = {
  "class": "sh-stack sh-results"
};
var _hoisted_75 = {
  "class": "sh-hero-head"
};
var _hoisted_76 = {
  "class": "sh-hero-caption sh-muted"
};
var _hoisted_77 = {
  "class": "sh-metrics sh-muted"
};
var _hoisted_78 = {
  key: 0
};
var _hoisted_79 = {
  "class": "sh-hero-chart"
};
var _hoisted_80 = {
  "class": "sh-stackbar"
};
var _hoisted_81 = ["title"];
var _hoisted_82 = {
  "class": "sh-legend"
};
var _hoisted_83 = {
  key: 0,
  "class": "sh-warning"
};
var _hoisted_84 = {
  "class": "sh-card sh-panel"
};
var _hoisted_85 = {
  "class": "sh-breakdown"
};
var _hoisted_86 = {
  "class": "sh-breakdown-group sh-divider-bottom"
};
var _hoisted_87 = {
  "class": "sh-row"
};
var _hoisted_88 = {
  "class": "sh-row"
};
var _hoisted_89 = {
  "class": "sh-row"
};
var _hoisted_90 = {
  "class": "sh-breakdown-group sh-divider-bottom"
};
var _hoisted_91 = {
  key: 0,
  "class": "sh-row"
};
var _hoisted_92 = {
  "class": "sh-row"
};
var _hoisted_93 = {
  key: 0,
  "class": "sh-row-sub"
};
var _hoisted_94 = {
  key: 1,
  "class": "sh-row"
};
var _hoisted_95 = {
  key: 2,
  "class": "sh-row"
};
var _hoisted_96 = {
  key: 3,
  "class": "sh-row"
};
var _hoisted_97 = {
  "class": "sh-row"
};
var _hoisted_98 = {
  "class": "sh-breakdown-group sh-divider-bottom"
};
var _hoisted_99 = {
  "class": "sh-row"
};
var _hoisted_100 = {
  "class": "sh-row"
};
var _hoisted_101 = {
  key: 0,
  "class": "sh-row"
};
var _hoisted_102 = {
  key: 1,
  "class": "sh-row"
};
var _hoisted_103 = {
  key: 2,
  "class": "sh-row"
};
var _hoisted_104 = {
  "class": "sh-breakdown-group sh-breakdown-group-last"
};
var _hoisted_105 = {
  "class": "sh-row"
};
var _hoisted_106 = {
  "class": "sh-card sh-panel"
};
var _hoisted_107 = {
  "class": "sh-display sh-target-title"
};
var _hoisted_108 = {
  "class": "sh-seg sh-seg-space"
};
var _hoisted_109 = ["onClick"];
var _hoisted_110 = {
  key: 0,
  "class": "sh-target-box"
};
var _hoisted_111 = {
  "class": "sh-num sh-display sh-target-value sh-target-value-main"
};
var _hoisted_112 = {
  "class": "sh-target-help sh-faint"
};
var _hoisted_113 = {
  key: 1,
  "class": "sh-target-flow"
};
var _hoisted_114 = {
  "class": "sh-field"
};
var _hoisted_115 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_116 = ["value"];
var _hoisted_117 = {
  "class": "sh-target-mini-grid"
};
var _hoisted_118 = {
  "class": "sh-target-mini"
};
var _hoisted_119 = {
  "class": "sh-num sh-display sh-target-value sh-target-value-small"
};
var _hoisted_120 = {
  "class": "sh-target-mini"
};
var _hoisted_121 = {
  "class": "sh-target-help sh-faint"
};
var _hoisted_122 = {
  key: 2,
  "class": "sh-target-flow"
};
var _hoisted_123 = {
  "class": "sh-field"
};
var _hoisted_124 = {
  "class": "sh-inwrap sh-field-input"
};
var _hoisted_125 = ["value"];
var _hoisted_126 = {
  "class": "sh-target-box"
};
var _hoisted_127 = {
  "class": "sh-target-caption sh-muted"
};
var _hoisted_128 = {
  "class": "sh-num sh-display sh-target-value"
};
var _hoisted_129 = {
  key: 1,
  "class": "sh-card sh-panel sh-embed-card"
};
var _hoisted_130 = ["value"];
var _hoisted_131 = {
  "class": "sh-embed-actions"
};
var _hoisted_132 = {
  key: 2,
  "class": "sh-powered"
};
var _hoisted_133 = {
  "class": "sh-modal-card"
};
var _hoisted_134 = {
  "class": "sh-modal-head"
};
var _hoisted_135 = {
  "class": "sh-modal-body"
};
var _hoisted_136 = {
  "class": "sh-preview-wrap"
};
var _hoisted_137 = ["src"];
import { computed, defineComponent, h, reactive, ref } from 'vue';
import { TOOL_EMBED_PROPS, buildEmbedSnippet, useToolEmbedSupport } from './shared/toolEmbed';
import { useTimedFlag, writeToClipboard } from './shared/toolClipboard';
var NFT_RATE = 0.055;
var SERVICES_FLAT = 44.0;
var PENALTY_RATE = 0.055;
var GST = 1.1;
var TIER_BREAK = 4000;
export default {
  __name: 'ebayAuCalculator',
  props: TOOL_EMBED_PROPS,
  setup: function setup(__props) {
    var props = __props;
    var BRAND = {
      brand: '#0072d6',
      brand600: '#0061b6',
      brandSoft: '#e8f2fc',
      ring: '#cce3f7',
      ink: '#222a44',
      text: '#1f1f1f',
      muted: '#5d6772',
      faint: '#99a1ac',
      line: '#e4e8ee',
      bg: '#f4f7fa',
      surface: '#ffffff',
      pos: '#00c489',
      pos700: '#0a8a63',
      posSoft: '#e6f8f1',
      neg: '#ff492c',
      negSoft: '#ffe9e4',
      warn: '#ffa127',
      warnSoft: '#fff2e0',
      pink: '#ff3969'
    };
    var PLANS = {
      free: {
        label: 'Free selling',
        sub: '<= $25k/yr',
        orderFee: 0,
        over4000: 0,
        intl: 0.03,
        monthly: 0,
        flat: 0
      },
      proStarter: {
        label: 'Pro Starter',
        sub: '> $25k - no fee',
        orderFee: 0.30,
        over4000: 0.025,
        intl: 0.011,
        monthly: 0,
        flat: 0.134
      },
      proBasic: {
        label: 'Pro Basic',
        sub: '$27.45/mo',
        orderFee: 0.33,
        over4000: 0.0275,
        intl: 0.011,
        monthly: 27.45,
        tiers: {
          1: 0.0803,
          2: 0.1144,
          3: 0.1243,
          4: 0.1309
        }
      },
      proFeatured: {
        label: 'Pro Featured',
        sub: '$82.45/mo',
        orderFee: 0.33,
        over4000: 0.0275,
        intl: 0.011,
        monthly: 82.45,
        tiers: {
          1: 0.0726,
          2: 0.1034,
          3: 0.1122,
          4: 0.1177
        }
      },
      proAnchor: {
        label: 'Pro Anchor',
        sub: '$604.95/mo',
        orderFee: 0.33,
        over4000: 0.0275,
        intl: 0.011,
        monthly: 604.95,
        tiers: {
          1: 0.0682,
          2: 0.0968,
          3: 0.1056,
          4: 0.1111
        }
      }
    };
    var CATEGORIES = [{
      id: 'general',
      label: 'Most categories',
      tier: 2
    }, {
      id: 'tech_dev',
      label: 'Tech devices (phones, TVs, cameras...)',
      tier: 1
    }, {
      id: 'appliance',
      label: 'Home appliances',
      tier: 1
    }, {
      id: 'vehicle',
      label: 'Vehicle parts & accessories',
      tier: 3
    }, {
      id: 'fashion',
      label: 'Clothing, shoes & accessories',
      tier: 4
    }, {
      id: 'beauty',
      label: 'Health & beauty',
      tier: 4
    }, {
      id: 'jewel',
      label: 'Jewellery & watches',
      tier: 4
    }, {
      id: 'media',
      label: 'Books, movies, music, video games',
      tier: 4
    }, {
      id: 'collect',
      label: 'Collectables & antiques',
      tier: 4
    }, {
      id: 'sport',
      label: 'Sporting goods',
      tier: 4
    }, {
      id: 'biz',
      label: 'Business & industrial',
      tier: 4
    }, {
      id: 'techacc',
      label: 'Tech accessories (cables, cases...)',
      tier: 4
    }, {
      id: 'nft',
      label: 'Non-fungible tokens (NFTs)',
      tier: 2,
      special: 'nft'
    }, {
      id: 'services',
      label: 'Services (Classified Ad)',
      tier: 2,
      special: 'services'
    }];
    var SORTED_CATEGORIES = [].concat(CATEGORIES).sort(function (a, b) {
      if (a.id === 'general') {
        return -1;
      }
      if (b.id === 'general') {
        return 1;
      }
      return a.label.localeCompare(b.label);
    });
    var PLAN_KEYS = Object.keys(PLANS);
    var PLAN_ICONS = {
      free: 'gift',
      proStarter: 'rocket',
      proBasic: 'store',
      proFeatured: 'star',
      proAnchor: 'anchor'
    };
    var REVERSE_TABS = [{
      key: 'breakeven',
      label: 'Breakeven'
    }, {
      key: 'profit',
      label: 'Target $'
    }, {
      key: 'margin',
      label: 'Target %'
    }];
    var ICONS = {
      info: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 16v-4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8h.01'
        }
      }],
      chevronDown: [{
        tag: 'path',
        attrs: {
          d: 'm6 9 6 6 6-6'
        }
      }],
      chevronRight: [{
        tag: 'path',
        attrs: {
          d: 'm9 18 6-6-6-6'
        }
      }],
      rotateCcw: [{
        tag: 'path',
        attrs: {
          d: 'M3 2v6h6'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M3 8a9 9 0 1 0 3-6.7L3 4'
        }
      }],
      copy: [{
        tag: 'rect',
        attrs: {
          x: 9,
          y: 9,
          width: 13,
          height: 13,
          rx: 2,
          ry: 2
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
        }
      }],
      check: [{
        tag: 'path',
        attrs: {
          d: 'M20 6 9 17l-5-5'
        }
      }],
      alertTriangle: [{
        tag: 'path',
        attrs: {
          d: 'm10.29 3.86-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.71-3.14l-8-14a2 2 0 0 0-3.42 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 9v4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 17h.01'
        }
      }],
      trendingUp: [{
        tag: 'path',
        attrs: {
          d: 'm22 7-8.5 8.5-5-5L2 17'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M16 7h6v6'
        }
      }],
      target: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 6
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 2
        }
      }],
      layers: [{
        tag: 'path',
        attrs: {
          d: 'm12.83 2.18 8 4a1 1 0 0 1 0 1.64l-8 4a2 2 0 0 1-1.66 0l-8-4a1 1 0 0 1 0-1.64l8-4a2 2 0 0 1 1.66 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 12 9.17 4.59a2 2 0 0 0 1.66 0L22 12'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 16 9.17 4.59a2 2 0 0 0 1.66 0L22 16'
        }
      }],
      gift: [{
        tag: 'rect',
        attrs: {
          x: 3,
          y: 8,
          width: 18,
          height: 4,
          rx: 1
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8v13'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8H7.5a2.5 2.5 0 1 1 0-5C10.5 3 12 8 12 8Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8h4.5a2.5 2.5 0 1 0 0-5C13.5 3 12 8 12 8Z'
        }
      }],
      rocket: [{
        tag: 'path',
        attrs: {
          d: 'M4.5 16.5c-1.5 1.26-1.5 5.5-1.5 5.5s4.24 0 5.5-1.5c.7-.84.7-2.16 0-3l-1-1c-.84-.7-2.16-.7-3 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm12 15-3-3a21.5 21.5 0 0 1 9-9 21.5 21.5 0 0 1-3 9Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M9 12H5a2 2 0 0 1-2-2c0-1.5 1.5-3 3-3h4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 15v4c0 1.5 1.5 3 3 3a2 2 0 0 0 2-2v-4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M15 9h.01'
        }
      }],
      store: [{
        tag: 'path',
        attrs: {
          d: 'M3 9h18'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 9V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M4 9v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M9 14h6'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M9 18h6'
        }
      }],
      star: [{
        tag: 'path',
        attrs: {
          d: 'm12 2 3.09 6.26 6.91 1-5 4.87L18.18 21 12 17.77 5.82 21 7 14.13 2 9.26l6.91-1L12 2Z'
        }
      }],
      anchor: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 5,
          r: 3
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 22V8'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 12H2a10 10 0 0 0 20 0h-3'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 12a7 7 0 0 0 14 0'
        }
      }],
      x: [{
        tag: 'path',
        attrs: {
          d: 'M18 6 6 18'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm6 6 12 12'
        }
      }]
    };
    var SvgIcon = defineComponent({
      name: 'SvgIcon',
      inheritAttrs: false,
      props: {
        name: {
          type: String,
          required: true
        },
        size: {
          type: [Number, String],
          "default": 24
        }
      },
      setup: function setup(props, _ref) {
        var attrs = _ref.attrs;
        return function () {
          var nodes = ICONS[props.name] || [];
          return h('svg', _objectSpread(_objectSpread({}, attrs), {}, {
            xmlns: 'http://www.w3.org/2000/svg',
            width: props.size,
            height: props.size,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 2,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'aria-hidden': 'true'
          }), nodes.map(function (node, index) {
            return h(node.tag, _objectSpread({
              key: index
            }, node.attrs));
          }));
        };
      }
    });
    function variableRate(planKey, tier, special) {
      if (planKey === 'free') {
        return 0;
      }
      if (special === 'nft') {
        return NFT_RATE;
      }
      if (planKey === 'proStarter') {
        return PLANS.proStarter.flat;
      }
      return PLANS[planKey].tiers[tier];
    }
    function ebayFees(state) {
      var planKey = state.planKey,
        tier = state.tier,
        special = state.special,
        totalSale = state.totalSale,
        international = state.international,
        status = state.status,
        adRate = state.adRate,
        abnExempt = state.abnExempt;
      var plan = PLANS[planKey];
      if (!(totalSale > 0)) {
        return {
          orderFee: 0,
          fvf: 0,
          penalty: 0,
          intl: 0,
          promoted: 0,
          total: 0
        };
      }
      var orderFee = planKey === 'free' ? 0 : plan.orderFee;
      var fvf;
      if (planKey === 'free') {
        fvf = 0;
      } else if (special === 'services') {
        fvf = orderFee + SERVICES_FLAT;
      } else if (special === 'nft') {
        fvf = orderFee + NFT_RATE * totalSale;
      } else {
        var rate = variableRate(planKey, tier, special);
        fvf = orderFee + rate * Math.min(totalSale, TIER_BREAK) + plan.over4000 * Math.max(0, totalSale - TIER_BREAK);
      }
      var penalty = status !== 'above' ? PENALTY_RATE * totalSale : 0;
      var intl = international ? plan.intl * totalSale : 0;
      var promotedBase = adRate > 0 ? totalSale * (adRate / 100) : 0;
      if (abnExempt) {
        fvf /= GST;
        penalty /= GST;
        intl /= GST;
      }
      var promoted = abnExempt ? promotedBase : promotedBase * GST;
      return {
        orderFee: abnExempt ? orderFee / GST : orderFee,
        fvf: fvf,
        penalty: penalty,
        intl: intl,
        promoted: promoted,
        total: fvf + penalty + intl + promoted
      };
    }
    function compute(state, soldPriceOverride) {
      var soldPrice = soldPriceOverride !== null && soldPriceOverride !== void 0 ? soldPriceOverride : state.soldPrice;
      var totalSale = soldPrice + state.shippingCharged;
      var category = CATEGORIES.find(function (item) {
        return item.id === state.categoryId;
      }) || CATEGORIES[0];
      var fees = ebayFees({
        planKey: state.planKey,
        tier: category.tier,
        special: category.special,
        totalSale: totalSale,
        international: state.international,
        status: state.status,
        adRate: state.adRate,
        abnExempt: state.abnExempt
      });
      var subFull = state.amortiseSub && state.itemsPerMonth > 0 ? PLANS[state.planKey].monthly / state.itemsPerMonth : 0;
      var subPerItem = state.abnExempt ? subFull / GST : subFull;
      var gstOnRevenue = state.remitGst ? totalSale * (state.gstRate / (100 + state.gstRate)) : 0;
      var cashCosts = state.itemCost + state.shippingCost + state.otherCosts + subPerItem;
      var totalFees = fees.total + subPerItem;
      var netProfit = totalSale - fees.total - cashCosts - gstOnRevenue;
      return _objectSpread(_objectSpread({
        totalSale: totalSale
      }, fees), {}, {
        subPerItem: subPerItem,
        gstOnRevenue: gstOnRevenue,
        costs: cashCosts,
        totalFees: totalFees,
        netProfit: netProfit,
        margin: totalSale > 0 ? netProfit / totalSale : 0,
        roi: cashCosts > 0 ? netProfit / cashCosts : null,
        effFeeRate: totalSale > 0 ? fees.total / totalSale : 0
      });
    }
    function solve(state, targetFn) {
      var low = 0;
      var high = 1000000;
      for (var index = 0; index < 80; index += 1) {
        var middle = (low + high) / 2;
        if (targetFn(compute(state, middle)) > 0) {
          high = middle;
        } else {
          low = middle;
        }
      }
      return (low + high) / 2;
    }
    function fmt(value) {
      return Number.isFinite(value) ? value.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) : '—';
    }
    function pct(value) {
      return Number.isFinite(value) ? "".concat((value * 100).toFixed(1), "%") : '—';
    }
    function parseNumericValue(value) {
      if (value === '') {
        return 0;
      }
      var parsed = Number.parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    function rowLabelStyle(strong) {
      return {
        color: strong ? BRAND.ink : BRAND.muted,
        fontWeight: strong ? 600 : 400
      };
    }
    function rowValueStyle(tone, strong) {
      var color = BRAND.muted;
      if (tone === 'neg') {
        color = BRAND.neg;
      } else if (tone === 'pos') {
        color = BRAND.pos700;
      } else if (strong) {
        color = BRAND.ink;
      }
      return {
        color: color,
        fontWeight: strong ? 600 : 400
      };
    }
    var defaults = {
      soldPrice: 120,
      shippingCharged: 12,
      itemCost: 45,
      shippingCost: 9,
      otherCosts: 0,
      planKey: 'proStarter',
      categoryId: 'general',
      status: 'above',
      international: false,
      adRate: 0,
      abnExempt: false,
      remitGst: false,
      gstRate: 10,
      amortiseSub: false,
      itemsPerMonth: 50
    };
    var blank = {
      soldPrice: 0,
      shippingCharged: 0,
      itemCost: 0,
      shippingCost: 0,
      otherCosts: 0,
      planKey: 'proStarter',
      categoryId: 'general',
      status: 'above',
      international: false,
      adRate: 0,
      abnExempt: false,
      remitGst: false,
      gstRate: 10,
      amortiseSub: false,
      itemsPerMonth: 50
    };
    var inputs = reactive(_objectSpread({}, defaults));
    var showAdvanced = ref(false);
    var reverseTab = ref('breakeven');
    var _useTimedFlag = useTimedFlag(1600),
      copied = _useTimedFlag.flag,
      triggerCopied = _useTimedFlag.trigger,
      resetCopied = _useTimedFlag.reset;
    var _useTimedFlag2 = useTimedFlag(1500),
      embedCopied = _useTimedFlag2.flag,
      triggerEmbedCopied = _useTimedFlag2.trigger,
      resetEmbedCopied = _useTimedFlag2.reset;
    var _useToolEmbedSupport = useToolEmbedSupport({
        props: props
      }),
      rootRef = _useToolEmbedSupport.rootRef,
      previewFrameRef = _useToolEmbedSupport.previewFrameRef,
      showPreview = _useToolEmbedSupport.showPreview,
      isEmbed = _useToolEmbedSupport.isEmbed,
      pageUrl = _useToolEmbedSupport.pageUrl,
      previewSrc = _useToolEmbedSupport.previewSrc,
      showEmbedCard = _useToolEmbedSupport.showEmbedCard,
      closePreview = _useToolEmbedSupport.closePreview;
    var targetProfit = ref(30);
    var targetMargin = ref(20);
    var result = computed(function () {
      return compute(inputs);
    });
    var selectedCategory = computed(function () {
      return CATEGORIES.find(function (item) {
        return item.id === inputs.categoryId;
      }) || CATEGORIES[0];
    });
    var loss = computed(function () {
      return result.value.netProfit < 0;
    });
    var breakeven = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit;
      });
    });
    var priceForProfit = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit - targetProfit.value;
      });
    });
    var priceForMargin = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit - targetMargin.value / 100 * current.totalSale;
      });
    });
    var maxItemCost = computed(function () {
      return inputs.itemCost + (result.value.netProfit - targetProfit.value);
    });
    var hasBasis = computed(function () {
      return inputs.soldPrice > 0 || inputs.shippingCharged > 0 || inputs.itemCost > 0 || inputs.shippingCost > 0 || inputs.otherCosts > 0;
    });
    var planCompare = computed(function () {
      var items = PLAN_KEYS.map(function (key) {
        return _objectSpread(_objectSpread({
          key: key
        }, PLANS[key]), {}, {
          res: compute(_objectSpread(_objectSpread({}, inputs), {}, {
            planKey: key
          }))
        });
      });
      var best = Math.max.apply(Math, _toConsumableArray(items.map(function (item) {
        return item.res.netProfit;
      })));
      return items.map(function (item) {
        var neg = item.res.netProfit < 0;
        var width = Math.max(0, Math.min(100, item.res.netProfit / (best || 1) * 100));
        return _objectSpread(_objectSpread({}, item), {}, {
          neg: neg,
          isBest: Math.abs(item.res.netProfit - best) < 0.005,
          barWidth: neg ? 6 : width
        });
      });
    });
    var segments = computed(function () {
      return [{
        label: 'eBay fees',
        value: Math.max(result.value.totalFees, 0),
        color: BRAND.pink
      }, {
        label: 'Item cost',
        value: inputs.itemCost,
        color: '#8a93a4'
      }, {
        label: 'Shipping cost',
        value: inputs.shippingCost,
        color: '#c2cdd6'
      }, {
        label: 'Other + GST',
        value: inputs.otherCosts + result.value.gstOnRevenue + result.value.subPerItem,
        color: '#9cc6ee'
      }, {
        label: loss.value ? 'Loss' : 'Your profit',
        value: Math.abs(result.value.netProfit),
        color: loss.value ? BRAND.neg : BRAND.pos
      }].filter(function (segment) {
        return segment.value > 0;
      });
    });
    var segmentTotal = computed(function () {
      return segments.value.reduce(function (total, segment) {
        return total + segment.value;
      }, 0) || 1;
    });
    var embedSnippet = computed(function () {
      return buildEmbedSnippet({
        pageUrl: pageUrl.value,
        iframeTitle: 'eBay Australia Fee & Profit Calculator by SaleHoo',
        initialHeight: 1600
      });
    });
    var heroStyle = computed(function () {
      return loss.value ? {
        background: BRAND.negSoft,
        border: "1px solid ".concat(BRAND.neg, "33")
      } : {
        background: "linear-gradient(135deg, ".concat(BRAND.posSoft, ", #ffffff)"),
        border: "1px solid ".concat(BRAND.pos, "33")
      };
    });
    function setNumberInput(key, value) {
      inputs[key] = parseNumericValue(value);
    }
    function setTargetProfitValue(value) {
      targetProfit.value = parseNumericValue(value);
    }
    function setTargetMarginValue(value) {
      targetMargin.value = parseNumericValue(value);
    }
    function copySummary() {
      return _copySummary.apply(this, arguments);
    }
    function _copySummary() {
      _copySummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var lines, didCopy;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              lines = ['eBay AU sale - estimate', "Plan: ".concat(PLANS[inputs.planKey].label, " \xB7 ").concat(selectedCategory.value.label), "Sold ".concat(fmt(inputs.soldPrice), " + ship ").concat(fmt(inputs.shippingCharged), " = ").concat(fmt(result.value.totalSale)), "eBay fees: ".concat(fmt(result.value.totalFees), " (").concat(pct(result.value.effFeeRate), " effective)"), "Costs: ".concat(fmt(result.value.costs)), "Net profit: ".concat(fmt(result.value.netProfit), " \xB7 margin ").concat(pct(result.value.margin)).concat(result.value.roi != null ? " \xB7 ROI ".concat(pct(result.value.roi)) : ''), "Breakeven sold price: ".concat(fmt(breakeven.value))];
              _context.next = 3;
              return writeToClipboard(lines.join('\n'));
            case 3:
              didCopy = _context.sent;
              if (didCopy) {
                _context.next = 7;
                break;
              }
              resetCopied();
              return _context.abrupt("return");
            case 7:
              triggerCopied();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _copySummary.apply(this, arguments);
    }
    function copyEmbed() {
      return _copyEmbed.apply(this, arguments);
    }
    function _copyEmbed() {
      _copyEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var didCopy;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return writeToClipboard(embedSnippet.value);
            case 2:
              didCopy = _context2.sent;
              if (didCopy) {
                _context2.next = 6;
                break;
              }
              resetEmbedCopied();
              return _context2.abrupt("return");
            case 6:
              triggerEmbedCopied();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _copyEmbed.apply(this, arguments);
    }
    function resetData() {
      Object.assign(inputs, blank);
      targetProfit.value = 0;
      targetMargin.value = 0;
      reverseTab.value = 'breakeven';
      showAdvanced.value = false;
      resetCopied();
      resetEmbedCopied();
      showPreview.value = false;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        "class": _normalizeClass(['sh-root', {
          embed: _unref(isEmbed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_unref(isEmbed) ? (_openBlock(), _createElementBlock("header", _hoisted_2, _cache[20] || (_cache[20] = [_createElementVNode("h1", {
        "class": "sh-display"
      }, " eBay Australia Fee & Profit Calculator ", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_cache[22] || (_cache[22] = _createElementVNode("h2", {
        "class": "sh-display sh-section-title"
      }, " Your seller plan ", -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PLAN_KEYS), function (planKey) {
        return _openBlock(), _createElementBlock("button", {
          key: planKey,
          type: "button",
          "class": _normalizeClass(["sh-chip sh-plan-chip", {
            on: inputs.planKey === planKey
          }]),
          onClick: function onClick($event) {
            return inputs.planKey = planKey;
          }
        }, [_createVNode(_unref(SvgIcon), {
          name: PLAN_ICONS[planKey],
          size: 18,
          "class": "sh-plan-icon",
          style: _normalizeStyle({
            color: inputs.planKey === planKey ? BRAND.brand : BRAND.faint
          })
        }, null, 8, ["name", "style"]), _createElementVNode("div", _hoisted_8, _toDisplayString(PLANS[planKey].label), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(PLANS[planKey].sub), 1)], 10, _hoisted_7);
      }), 128))]), inputs.planKey === 'free' ? (_openBlock(), _createElementBlock("p", _hoisted_10, [_createVNode(_unref(SvgIcon), {
        name: "check",
        size: 14,
        "class": "sh-note-icon"
      }), _cache[21] || (_cache[21] = _createTextVNode(" Free selling waives final value fees. You may still pay international, promoted-ad and optional listing fees - and a performance fee if you're Below Standard. "))])) : _createCommentVNode("", true)]), _createElementVNode("section", _hoisted_11, [_cache[53] || (_cache[53] = _createElementVNode("h2", {
        "class": "sh-display sh-section-title sh-section-title-space"
      }, " Sale data ", -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("label", _hoisted_13, [_createElementVNode("span", _hoisted_14, [_cache[24] || (_cache[24] = _createTextVNode(" Item sold price ")), _createElementVNode("span", _hoisted_15, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[23] || (_cache[23] = _createElementVNode("span", {
        "class": "bub"
      }, "Winning bid, Buy It Now or accepted offer. Excludes buyer coupons.", -1))])]), _createElementVNode("div", _hoisted_16, [_cache[25] || (_cache[25] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: inputs.soldPrice,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[0] || (_cache[0] = function ($event) {
          return setNumberInput('soldPrice', $event.target.value);
        })
      }, null, 40, _hoisted_17)])]), _createElementVNode("label", _hoisted_18, [_createElementVNode("span", _hoisted_19, [_cache[27] || (_cache[27] = _createTextVNode(" Shipping charged to buyer ")), _createElementVNode("span", _hoisted_20, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[26] || (_cache[26] = _createElementVNode("span", {
        "class": "bub"
      }, "What the buyer paid for postage. eBay fees apply to this too.", -1))])]), _createElementVNode("div", _hoisted_21, [_cache[28] || (_cache[28] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: inputs.shippingCharged,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[1] || (_cache[1] = function ($event) {
          return setNumberInput('shippingCharged', $event.target.value);
        })
      }, null, 40, _hoisted_22)])]), _createElementVNode("label", _hoisted_23, [_createElementVNode("span", _hoisted_24, [_cache[30] || (_cache[30] = _createTextVNode(" Your item cost ")), _createElementVNode("span", _hoisted_25, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[29] || (_cache[29] = _createElementVNode("span", {
        "class": "bub"
      }, "What you paid for the item (cost of goods).", -1))])]), _createElementVNode("div", _hoisted_26, [_cache[31] || (_cache[31] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: inputs.itemCost,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[2] || (_cache[2] = function ($event) {
          return setNumberInput('itemCost', $event.target.value);
        })
      }, null, 40, _hoisted_27)])]), _createElementVNode("label", _hoisted_28, [_createElementVNode("span", _hoisted_29, [_cache[33] || (_cache[33] = _createTextVNode(" Your postage cost ")), _createElementVNode("span", _hoisted_30, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[32] || (_cache[32] = _createElementVNode("span", {
        "class": "bub"
      }, "What the label actually costs you to send it.", -1))])]), _createElementVNode("div", _hoisted_31, [_cache[34] || (_cache[34] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: inputs.shippingCost,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[3] || (_cache[3] = function ($event) {
          return setNumberInput('shippingCost', $event.target.value);
        })
      }, null, 40, _hoisted_32)])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("label", _hoisted_34, [_cache[35] || (_cache[35] = _createElementVNode("span", {
        "class": "sh-field-caption sh-muted"
      }, "Item category", -1)), _createElementVNode("div", _hoisted_35, [_withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return inputs.categoryId = $event;
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SORTED_CATEGORIES), function (category) {
        return _openBlock(), _createElementBlock("option", {
          key: category.id,
          value: category.id
        }, _toDisplayString(category.label), 9, _hoisted_36);
      }), 128))], 512), [[_vModelSelect, inputs.categoryId]])])]), _createElementVNode("label", _hoisted_37, [_cache[37] || (_cache[37] = _createElementVNode("span", {
        "class": "sh-field-caption sh-muted"
      }, "Seller status", -1)), _createElementVNode("div", _hoisted_38, [_withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return inputs.status = $event;
        })
      }, _cache[36] || (_cache[36] = [_createElementVNode("option", {
        value: "above"
      }, " Above Standard / Top Rated ", -1), _createElementVNode("option", {
        value: "below"
      }, " Below Standard (+5.5%) ", -1)]), 512), [[_vModelSelect, inputs.status]])])])]), (inputs.planKey === 'free' || inputs.planKey === 'proStarter') && !selectedCategory.value.special && inputs.status === 'above' ? (_openBlock(), _createElementBlock("p", _hoisted_39, " On " + _toDisplayString(PLANS[inputs.planKey].label) + " the final value rate is the same across these categories, so the category mainly matters if you compare Pro Basic/Featured/Anchor below. ", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_40, [_createElementVNode("button", {
        type: "button",
        "class": "sh-display sh-advanced-toggle",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return showAdvanced.value = !showAdvanced.value;
        })
      }, [_createElementVNode("span", _hoisted_41, [_createVNode(_unref(SvgIcon), {
        name: "layers",
        size: 16,
        "class": "sh-advanced-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[38] || (_cache[38] = _createTextVNode(" Advanced options "))]), _createVNode(_unref(SvgIcon), {
        name: showAdvanced.value ? 'chevronDown' : 'chevronRight',
        size: 16
      }, null, 8, ["name"])]), showAdvanced.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("button", {
        type: "button",
        role: "switch",
        "aria-checked": inputs.international,
        "class": "sh-chip sh-toggle-chip",
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return inputs.international = !inputs.international;
        })
      }, [_createElementVNode("span", _hoisted_45, [_cache[39] || (_cache[39] = _createTextVNode(" International sale ")), _createElementVNode("span", _hoisted_46, " · " + _toDisplayString(pct(PLANS[inputs.planKey].intl)) + " fee", 1)]), _createElementVNode("span", {
        "class": _normalizeClass(["sh-switch", {
          on: inputs.international
        }])
      }, _cache[40] || (_cache[40] = [_createElementVNode("i", null, null, -1)]), 2)], 8, _hoisted_44), _createElementVNode("button", {
        type: "button",
        role: "switch",
        "aria-checked": inputs.abnExempt,
        "class": "sh-chip sh-toggle-chip",
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return inputs.abnExempt = !inputs.abnExempt;
        })
      }, [_cache[42] || (_cache[42] = _createElementVNode("span", {
        "class": "sh-toggle-label"
      }, [_createTextVNode(" Registered for GST exemption "), _createElementVNode("span", {
        "class": "sh-toggle-hint"
      }, " · ABN, fees ex-GST")], -1)), _createElementVNode("span", {
        "class": _normalizeClass(["sh-switch", {
          on: inputs.abnExempt
        }])
      }, _cache[41] || (_cache[41] = [_createElementVNode("i", null, null, -1)]), 2)], 8, _hoisted_47)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("label", _hoisted_49, [_createElementVNode("span", _hoisted_50, [_cache[44] || (_cache[44] = _createTextVNode(" Promoted Listings ad rate ")), _createElementVNode("span", _hoisted_51, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[43] || (_cache[43] = _createElementVNode("span", {
        "class": "bub"
      }, "Your chosen ad rate %, charged on the total sale when it sells via the ad.", -1))])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("input", {
        value: inputs.adRate,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.1",
        min: "0",
        onInput: _cache[9] || (_cache[9] = function ($event) {
          return setNumberInput('adRate', $event.target.value);
        })
      }, null, 40, _hoisted_53)])]), _createElementVNode("label", _hoisted_54, [_createElementVNode("span", _hoisted_55, [_cache[46] || (_cache[46] = _createTextVNode(" Other costs per sale ")), _createElementVNode("span", _hoisted_56, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[45] || (_cache[45] = _createElementVNode("span", {
        "class": "bub"
      }, "Packaging, inserts, returns provision, flat ad fees, etc.", -1))])]), _createElementVNode("div", _hoisted_57, [_cache[47] || (_cache[47] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: inputs.otherCosts,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[10] || (_cache[10] = function ($event) {
          return setNumberInput('otherCosts', $event.target.value);
        })
      }, null, 40, _hoisted_58)])])]), _createElementVNode("button", {
        type: "button",
        role: "switch",
        "aria-checked": inputs.remitGst,
        "class": "sh-chip sh-toggle-chip",
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return inputs.remitGst = !inputs.remitGst;
        })
      }, [_createElementVNode("span", _hoisted_60, [_cache[48] || (_cache[48] = _createTextVNode(" Set aside GST on my revenue ")), _createElementVNode("span", _hoisted_61, " · " + _toDisplayString(inputs.gstRate) + "% - your ATO obligation, not an eBay fee", 1)]), _createElementVNode("span", {
        "class": _normalizeClass(["sh-switch", {
          on: inputs.remitGst
        }])
      }, _cache[49] || (_cache[49] = [_createElementVNode("i", null, null, -1)]), 2)], 8, _hoisted_59), PLANS[inputs.planKey].monthly > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("button", {
        type: "button",
        role: "switch",
        "aria-checked": inputs.amortiseSub,
        "class": "sh-chip sh-toggle-chip",
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return inputs.amortiseSub = !inputs.amortiseSub;
        })
      }, [_createElementVNode("span", _hoisted_63, [_createTextVNode(" Spread " + _toDisplayString(PLANS[inputs.planKey].label) + " subscription across sales ", 1), _createElementVNode("span", _hoisted_64, " · " + _toDisplayString(fmt(PLANS[inputs.planKey].monthly)) + "/mo", 1)]), _createElementVNode("span", {
        "class": _normalizeClass(["sh-switch", {
          on: inputs.amortiseSub
        }])
      }, _cache[50] || (_cache[50] = [_createElementVNode("i", null, null, -1)]), 2)], 8, _hoisted_62), inputs.amortiseSub ? (_openBlock(), _createElementBlock("label", _hoisted_65, [_createElementVNode("span", _hoisted_66, [_cache[52] || (_cache[52] = _createTextVNode(" Sales per month ")), _createElementVNode("span", _hoisted_67, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        "class": "sh-tip-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[51] || (_cache[51] = _createElementVNode("span", {
        "class": "bub"
      }, "Used to spread the monthly subscription per sale.", -1))])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("input", {
        value: inputs.itemsPerMonth,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "1",
        min: "0",
        onInput: _cache[13] || (_cache[13] = function ($event) {
          return setNumberInput('itemsPerMonth', $event.target.value);
        })
      }, null, 40, _hoisted_69)])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_70, [_createElementVNode("h2", _hoisted_71, [_createVNode(_unref(SvgIcon), {
        name: "trendingUp",
        size: 16,
        "class": "sh-compare-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[54] || (_cache[54] = _createTextVNode(" Net profit by plan "))]), _cache[55] || (_cache[55] = _createElementVNode("p", {
        "class": "sh-compare-note"
      }, " Same sale, every plan - subscription excluded unless you switched it on above. ", -1)), _createElementVNode("div", _hoisted_72, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planCompare.value, function (plan) {
        return _openBlock(), _createElementBlock("div", {
          key: plan.key,
          "class": "sh-compare-row"
        }, [_createElementVNode("span", {
          "class": "sh-compare-label",
          style: _normalizeStyle({
            color: inputs.planKey === plan.key ? BRAND.ink : BRAND.muted,
            fontWeight: inputs.planKey === plan.key ? 700 : 400
          })
        }, _toDisplayString(plan.label), 5), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", {
          "class": "sh-compare-fill",
          style: _normalizeStyle({
            width: "".concat(plan.barWidth, "%"),
            background: plan.neg ? BRAND.neg : plan.isBest ? BRAND.pos : '#9fe2cb'
          })
        }, null, 4)]), _createElementVNode("span", {
          "class": "sh-num sh-compare-value",
          style: _normalizeStyle({
            color: plan.neg ? BRAND.neg : BRAND.ink
          })
        }, _toDisplayString(fmt(plan.res.netProfit)), 5)]);
      }), 128))])])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("section", {
        "class": "sh-hero",
        style: _normalizeStyle(heroStyle.value)
      }, [_createElementVNode("div", _hoisted_75, [_createElementVNode("span", _hoisted_76, _toDisplayString(loss.value ? 'You lose on this sale' : 'You take home'), 1), _createElementVNode("button", {
        type: "button",
        "class": "sh-btn sh-copy-btn",
        onClick: copySummary
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(copied) ? 'check' : 'copy',
        size: 12,
        style: _normalizeStyle({
          color: _unref(copied) ? BRAND.pos : 'currentColor'
        })
      }, null, 8, ["name", "style"]), _createTextVNode(" " + _toDisplayString(_unref(copied) ? 'Copied' : 'Copy'), 1)])]), _createElementVNode("div", {
        "class": "sh-num sh-display sh-hero-amount",
        style: _normalizeStyle({
          color: loss.value ? BRAND.neg : BRAND.pos700
        })
      }, _toDisplayString(fmt(result.value.netProfit)), 5), _createElementVNode("div", _hoisted_77, [_createElementVNode("span", null, [_cache[56] || (_cache[56] = _createTextVNode(" Margin ")), _createElementVNode("b", {
        "class": "sh-num",
        style: _normalizeStyle({
          color: BRAND.ink
        })
      }, _toDisplayString(pct(result.value.margin)), 5)]), result.value.roi != null ? (_openBlock(), _createElementBlock("span", _hoisted_78, [_cache[57] || (_cache[57] = _createTextVNode(" ROI ")), _createElementVNode("b", {
        "class": "sh-num",
        style: _normalizeStyle({
          color: BRAND.ink
        })
      }, _toDisplayString(pct(result.value.roi)), 5)])) : _createCommentVNode("", true), _createElementVNode("span", null, [_cache[58] || (_cache[58] = _createTextVNode(" Effective fee ")), _createElementVNode("b", {
        "class": "sh-num",
        style: _normalizeStyle({
          color: BRAND.ink
        })
      }, _toDisplayString(pct(result.value.effFeeRate)), 5)])]), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("div", {
          key: segment.label,
          title: "".concat(segment.label, ": ").concat(fmt(segment.value)),
          "class": "sh-stackbar-segment",
          style: _normalizeStyle({
            width: "".concat(segment.value / segmentTotal.value * 100, "%"),
            background: segment.color
          })
        }, null, 12, _hoisted_81);
      }), 128))]), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("span", {
          key: "".concat(segment.label, "-legend"),
          "class": "sh-legend-item sh-muted"
        }, [_createElementVNode("span", {
          "class": "sh-swatch",
          style: _normalizeStyle({
            background: segment.color
          })
        }, null, 4), _createTextVNode(" " + _toDisplayString(segment.label) + " " + _toDisplayString(fmt(segment.value)), 1)]);
      }), 128))])])], 4), loss.value ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_createVNode(_unref(SvgIcon), {
        name: "alertTriangle",
        size: 16,
        "class": "sh-warning-icon",
        style: _normalizeStyle({
          color: BRAND.warn
        })
      }, null, 8, ["style"]), _createElementVNode("span", null, [_cache[59] || (_cache[59] = _createTextVNode(" This sale loses money. Raise the price to at least ")), _createElementVNode("b", null, _toDisplayString(fmt(breakeven.value)), 1), _cache[60] || (_cache[60] = _createTextVNode(" to break even. "))])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_84, [_cache[65] || (_cache[65] = _createElementVNode("h2", {
        "class": "sh-display sh-section-title sh-section-title-tight"
      }, " Fee & cost breakdown ", -1)), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Item price ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('default', false))
      }, _toDisplayString(fmt(inputs.soldPrice)), 5)]), _createElementVNode("div", _hoisted_88, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Shipping charged ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('default', false))
      }, _toDisplayString(fmt(inputs.shippingCharged)), 5)]), _createElementVNode("div", _hoisted_89, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(true))
      }, " Total sale amount ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('default', true))
      }, _toDisplayString(fmt(result.value.totalSale)), 5)])]), _createElementVNode("div", _hoisted_90, [!selectedCategory.value.special && inputs.planKey !== 'free' ? (_openBlock(), _createElementBlock("div", _hoisted_91, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, _cache[61] || (_cache[61] = [_createTextVNode(" Order fee "), _createElementVNode("span", {
        "class": "sh-row-sub"
      }, "per order", -1)]), 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.orderFee)), 5)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_92, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, [_cache[62] || (_cache[62] = _createTextVNode(" Final value fee ")), inputs.planKey === 'free' ? (_openBlock(), _createElementBlock("span", _hoisted_93, "waived")) : _createCommentVNode("", true)], 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(inputs.planKey === 'free' ? 0 : result.value.fvf - (selectedCategory.value.special ? 0 : result.value.orderFee))), 5)]), result.value.penalty > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_94, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, _cache[63] || (_cache[63] = [_createTextVNode(" Performance fee "), _createElementVNode("span", {
        "class": "sh-row-sub"
      }, "+5.5%", -1)]), 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.penalty)), 5)])) : _createCommentVNode("", true), result.value.intl > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " International fee ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.intl)), 5)])) : _createCommentVNode("", true), result.value.promoted > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Promoted Listings ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.promoted)), 5)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_97, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(true))
      }, " Total eBay fees ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', true))
      }, " - " + _toDisplayString(fmt(result.value.total)), 5)])]), _createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Item cost ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(inputs.itemCost)), 5)]), _createElementVNode("div", _hoisted_100, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Postage cost ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(inputs.shippingCost)), 5)]), inputs.otherCosts > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_101, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Other costs ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(inputs.otherCosts)), 5)])) : _createCommentVNode("", true), result.value.subPerItem > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, " Subscription / sale ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.subPerItem)), 5)])) : _createCommentVNode("", true), result.value.gstOnRevenue > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_103, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(false))
      }, _cache[64] || (_cache[64] = [_createTextVNode(" GST set aside "), _createElementVNode("span", {
        "class": "sh-row-sub"
      }, "your ATO obligation", -1)]), 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle('neg', false))
      }, " - " + _toDisplayString(fmt(result.value.gstOnRevenue)), 5)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_createElementVNode("span", {
        "class": "sh-row-label",
        style: _normalizeStyle(rowLabelStyle(true))
      }, " Net profit ", 4), _createElementVNode("span", {
        "class": "sh-num sh-row-value",
        style: _normalizeStyle(rowValueStyle(loss.value ? 'neg' : 'pos', true))
      }, _toDisplayString(fmt(result.value.netProfit)), 5)])])])]), _createElementVNode("section", _hoisted_106, [_createElementVNode("h2", _hoisted_107, [_createVNode(_unref(SvgIcon), {
        name: "target",
        size: 16,
        "class": "sh-target-icon",
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[66] || (_cache[66] = _createTextVNode(" What price do I need? "))]), _createElementVNode("div", _hoisted_108, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(REVERSE_TABS, function (tab) {
        return _createElementVNode("button", {
          key: tab.key,
          type: "button",
          "class": _normalizeClass({
            on: reverseTab.value === tab.key
          }),
          onClick: function onClick($event) {
            return reverseTab.value = tab.key;
          }
        }, _toDisplayString(tab.label), 11, _hoisted_109);
      }), 64))]), reverseTab.value === 'breakeven' ? (_openBlock(), _createElementBlock("div", _hoisted_110, [_cache[67] || (_cache[67] = _createElementVNode("div", {
        "class": "sh-target-caption sh-muted"
      }, " Sell at this price to break even ", -1)), _createElementVNode("div", _hoisted_111, _toDisplayString(hasBasis.value ? fmt(breakeven.value) : '—'), 1), _createElementVNode("div", _hoisted_112, " at current costs & " + _toDisplayString(fmt(inputs.shippingCharged)) + " shipping ", 1)])) : _createCommentVNode("", true), reverseTab.value === 'profit' ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_createElementVNode("label", _hoisted_114, [_cache[69] || (_cache[69] = _createElementVNode("span", {
        "class": "sh-field-caption sh-muted"
      }, "Target profit per sale", -1)), _createElementVNode("div", _hoisted_115, [_cache[68] || (_cache[68] = _createElementVNode("span", {
        "class": "sh-pre"
      }, "$", -1)), _createElementVNode("input", {
        value: targetProfit.value,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "0.01",
        min: "0",
        onInput: _cache[14] || (_cache[14] = function ($event) {
          return setTargetProfitValue($event.target.value);
        })
      }, null, 40, _hoisted_116)])]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_cache[70] || (_cache[70] = _createElementVNode("div", {
        "class": "sh-target-caption sh-muted"
      }, " Sell at ", -1)), _createElementVNode("div", _hoisted_119, _toDisplayString(hasBasis.value || targetProfit.value > 0 ? fmt(priceForProfit.value) : '—'), 1)]), _createElementVNode("div", _hoisted_120, [_cache[71] || (_cache[71] = _createElementVNode("div", {
        "class": "sh-target-caption sh-muted"
      }, " Max item cost ", -1)), _createElementVNode("div", {
        "class": "sh-num sh-display sh-target-value sh-target-value-small",
        style: _normalizeStyle({
          color: maxItemCost.value < 0 ? BRAND.neg : BRAND.ink
        })
      }, _toDisplayString(hasBasis.value || targetProfit.value > 0 ? fmt(maxItemCost.value) : '—'), 5)])]), _createElementVNode("p", _hoisted_121, " Left: price needed at today's cost. Right: most you can pay for stock and still hit " + _toDisplayString(fmt(targetProfit.value)) + " at today's price. ", 1)])) : _createCommentVNode("", true), reverseTab.value === 'margin' ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_createElementVNode("label", _hoisted_123, [_cache[72] || (_cache[72] = _createElementVNode("span", {
        "class": "sh-field-caption sh-muted"
      }, "Target margin %", -1)), _createElementVNode("div", _hoisted_124, [_createElementVNode("input", {
        value: targetMargin.value,
        "class": "sh-num",
        type: "number",
        inputmode: "decimal",
        step: "1",
        min: "0",
        onInput: _cache[15] || (_cache[15] = function ($event) {
          return setTargetMarginValue($event.target.value);
        })
      }, null, 40, _hoisted_125)])]), _createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, " Sell at this price for a " + _toDisplayString(targetMargin.value) + "% margin ", 1), _createElementVNode("div", _hoisted_128, _toDisplayString(hasBasis.value || targetMargin.value > 0 ? fmt(priceForMargin.value) : '—'), 1)])])) : _createCommentVNode("", true)]), _createElementVNode("button", {
        type: "button",
        "class": "sh-btn sh-reset",
        onClick: resetData
      }, [_createVNode(_unref(SvgIcon), {
        name: "rotateCcw",
        size: 14
      }), _cache[73] || (_cache[73] = _createTextVNode(" Reset data "))])])]), _unref(showEmbedCard) ? (_openBlock(), _createElementBlock("section", _hoisted_129, [_cache[74] || (_cache[74] = _createElementVNode("h2", {
        "class": "sh-display sh-section-title sh-section-title-tight"
      }, " Add calculator to your site ", -1)), _cache[75] || (_cache[75] = _createElementVNode("p", {
        "class": "sh-embed-note sh-faint"
      }, " Copy the snippet and paste it into any page or blog post. It resizes to fit and works on mobile. ", -1)), _createElementVNode("textarea", {
        "class": "sh-embed-code sh-num",
        readonly: "",
        rows: "4",
        value: embedSnippet.value,
        "aria-label": "Embed code",
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return $event.target.select();
        })
      }, null, 8, _hoisted_130), _createElementVNode("div", _hoisted_131, [_createElementVNode("button", {
        type: "button",
        "class": "sh-btn sh-embed-copy",
        style: _normalizeStyle({
          background: BRAND.brand,
          color: '#fff',
          borderColor: BRAND.brand
        }),
        onClick: copyEmbed
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(embedCopied) ? 'check' : 'copy',
        size: 14
      }, null, 8, ["name"]), _createTextVNode(" " + _toDisplayString(_unref(embedCopied) ? 'Copied' : 'Copy embed code'), 1)], 4), _createElementVNode("button", {
        type: "button",
        "class": "sh-btn sh-embed-preview",
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return showPreview.value = !_unref(showPreview);
        })
      }, _toDisplayString(_unref(showPreview) ? 'Hide preview' : 'Preview embed'), 1)])])) : _createCommentVNode("", true), _unref(isEmbed) ? (_openBlock(), _createElementBlock("p", _hoisted_132, _cache[76] || (_cache[76] = [_createTextVNode(" Powered by "), _createElementVNode("a", {
        href: "https://www.salehoo.com",
        target: "_blank",
        rel: "noopener"
      }, "SaleHoo", -1)]))) : _createCommentVNode("", true)]), _unref(showPreview) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "sh-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "ebay-au-preview-title",
        onClick: _cache[19] || (_cache[19] = _withModifiers(function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        }, ["self"]))
      }, [_createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_cache[77] || (_cache[77] = _createElementVNode("h3", {
        id: "ebay-au-preview-title",
        "class": "sh-display"
      }, " Embed preview ", -1)), _createElementVNode("button", {
        type: "button",
        "class": "sh-modal-close",
        "aria-label": "Close preview",
        onClick: _cache[18] || (_cache[18] = function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        })
      }, [_createVNode(_unref(SvgIcon), {
        name: "x",
        size: 14
      })])]), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, [_createElementVNode("iframe", {
        ref_key: "previewFrameRef",
        ref: previewFrameRef,
        "class": "sh-preview-frame",
        src: _unref(previewSrc),
        title: "Embed preview",
        loading: "lazy"
      }, null, 8, _hoisted_137)])])])])) : _createCommentVNode("", true)], 2);
    };
  }
};